import { SkeletonLight } from '@/components/skeleton/skeleton.light';
import { ChevronRight } from '@nosinovacao/fe-icons';
import { ActionCard, If, useI18n } from '@nosinovacao/nosid-mfe-common';
import { useNavigate } from '@tanstack/react-router';
import { type NewContactState } from '../../-model/flow';
import { type LandingPageProps } from '../-model/props';

export function LandingPageLight({ isLoading, hasUsername }: Readonly<LandingPageProps>) {
  const { t } = useI18n();
  const navigate = useNavigate();

  const handleNavigate = (type: 'phone' | 'email' | 'username') => {
    if (type === 'username') {
      navigate({ to: '/home/change-contacts/username' });
      return;
    }
    const state: NewContactState = { type };
    navigate({ to: '/home/change-contacts/new-contact', state });
  };

  return (
    <SkeletonLight loading={isLoading} className="h-[4.5rem] w-full rounded" count={2}>
      <div className="grid gap-3">
        <ActionCard
          skin="light"
          variant="quick-link"
          preTitle={t('Home.ChangeContacts.LandingPage.Change')}
          title={t('Home.ChangeContacts.LandingPage.Phone')}
          subTitle={<></>}
          icon={<ChevronRight width={20} height={20} />}
          className="w-full border-solid border-nos-neutral-200 bg-nos-neutral-0"
          data-tid="card-change-phone"
          onClick={() => handleNavigate('phone')}
        />
        <ActionCard
          skin="light"
          variant="quick-link"
          preTitle={t('Home.ChangeContacts.LandingPage.Change')}
          title={t('Home.ChangeContacts.LandingPage.Email')}
          subTitle={<></>}
          icon={<ChevronRight width={20} height={20} />}
          className="w-full border-solid border-nos-neutral-200 bg-nos-neutral-0"
          data-tid="card-change-email"
          onClick={() => handleNavigate('email')}
        />
        <If condition={hasUsername}>
          <ActionCard
            skin="light"
            variant="quick-link"
            preTitle={t('Home.ChangeContacts.LandingPage.Manage')}
            title={t('Home.ChangeContacts.LandingPage.Username')}
            subTitle={<></>}
            icon={<ChevronRight width={20} height={20} />}
            className="w-full border-solid border-nos-neutral-200 bg-nos-neutral-0"
            data-tid="card-manage-username"
            onClick={() => handleNavigate('username')}
          />
        </If>
      </div>
    </SkeletonLight>
  );
}
